/* Tath Store — scripts propios. Vanilla, sin librerías. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Animaciones de entrada ------------------------------------------ */
  function initReveals() {
    var elementos = document.querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!elementos.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      elementos.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }

    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (entrada) {
        if (!entrada.isIntersecting) return;
        var el = entrada.target;
        var retraso = parseInt(el.getAttribute('data-mt-retraso') || '0', 10);
        setTimeout(function () { el.classList.add('mt-visible'); }, retraso);
        obs.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    elementos.forEach(function (el) { obs.observe(el); });

    /* Red de seguridad: si algo impide que el observador dispare,
       a los 2,5 s se muestra todo igualmente. Nunca una página en blanco. */
    setTimeout(function () {
      document.querySelectorAll('.mt-reveal:not(.mt-visible)').forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('mt-visible');
      });
    }, 2500);
  }

  /* --- FAQ (acordeón) --------------------------------------------------- */
  function initFaq(raiz) {
    var items = (raiz || document).querySelectorAll('.mt-faq__item');
    if (!items.length) return;

    items.forEach(function (item) {
      var boton = item.querySelector('.mt-faq__boton');
      if (!boton || boton.dataset.mtListo === '1') return;
      boton.dataset.mtListo = '1';

      boton.addEventListener('click', function () {
        var abierto = item.classList.contains('mt-abierto');
        var lista = item.closest('.mt-faq__lista');

        if (lista && lista.dataset.mtSolo === '1') {
          lista.querySelectorAll('.mt-faq__item.mt-abierto').forEach(function (otro) {
            if (otro === item) return;
            otro.classList.remove('mt-abierto');
            var b = otro.querySelector('.mt-faq__boton');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
        }

        item.classList.toggle('mt-abierto', !abierto);
        boton.setAttribute('aria-expanded', String(!abierto));
      });
    });
  }

  /* --- Galería del producto -------------------------------------------- */
  function initGaleria(raiz) {
    var galerias = (raiz || document).querySelectorAll('[data-mt-galeria]');
    if (!galerias.length) return;

    galerias.forEach(function (galeria) {
      if (galeria.dataset.mtListo === '1') return;
      galeria.dataset.mtListo = '1';

      var principal = galeria.querySelector('[data-mt-principal]');
      if (!principal) return;

      /* Cambia la foto grande SOLO cuando la nueva ya se ha descargado.
         Antes se cambiaba a ciegas y se veia el hueco mientras bajaba. */
      function mostrar(src, alt) {
        var pre = new Image();
        var hecho = false;

        function aplicar() {
          if (hecho) return;
          hecho = true;
          principal.src = src;
          principal.alt = alt;
          principal.style.opacity = '1';
        }

        pre.onload = aplicar;
        pre.onerror = aplicar;
        principal.style.opacity = '0';
        pre.src = src;

        if (pre.complete) aplicar();        /* ya estaba en memoria */
        setTimeout(aplicar, 2500);          /* red de seguridad */
      }

      galeria.querySelectorAll('[data-mt-mini]').forEach(function (mini) {
        mini.addEventListener('click', function () {
          var src = mini.getAttribute('data-mt-src');
          var alt = mini.getAttribute('data-mt-alt') || '';
          if (!src) return;
          mostrar(src, alt);
          galeria.querySelectorAll('[data-mt-mini]').forEach(function (m) {
            m.classList.toggle('mt-activa', m === mini);
          });
        });
      });

      /* Baja las demas fotos por detras, sin estorbar a la carga de la pagina,
         para que el primer clic en cada miniatura ya sea instantaneo. */
      function precargar() {
        galeria.querySelectorAll('[data-mt-mini]').forEach(function (m) {
          var s = m.getAttribute('data-mt-src');
          if (s) { var i = new Image(); i.src = s; }
        });
      }

      if ('requestIdleCallback' in window) {
        requestIdleCallback(precargar, { timeout: 3000 });
      } else {
        setTimeout(precargar, 1200);
      }
    });
  }

  /* --- Selector de variantes ------------------------------------------- */
  function initVariantes(raiz) {
    var bloques = (raiz || document).querySelectorAll('[data-mt-variantes]');
    if (!bloques.length) return;

    bloques.forEach(function (bloque) {
      if (bloque.dataset.mtListo === '1') return;
      bloque.dataset.mtListo = '1';

      var datos = bloque.querySelector('[data-mt-variantes-json]');
      if (!datos) return;

      var variantes;
      try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
      if (!variantes || !variantes.length) return;

      var inputId = bloque.querySelector('[data-mt-variante-id]');
      var precioAhora = bloque.querySelector('[data-mt-precio-ahora]');
      var precioAntes = bloque.querySelector('[data-mt-precio-antes]');
      var boton = bloque.querySelector('[data-mt-boton]');
      var textoDisponible = boton ? boton.getAttribute('data-mt-texto-disponible') : '';
      var textoAgotado = boton ? boton.getAttribute('data-mt-texto-agotado') : '';

      function seleccionActual() {
        var valores = [];
        bloque.querySelectorAll('[data-mt-opcion]').forEach(function (grupo) {
          var activa = grupo.querySelector('.mt-opcion__valor.mt-activa');
          valores.push(activa ? activa.getAttribute('data-mt-valor') : null);
        });
        return valores;
      }

      function actualiza() {
        var valores = seleccionActual();
        var encontrada = null;

        for (var i = 0; i < variantes.length; i++) {
          var v = variantes[i];
          var coincide = true;
          for (var j = 0; j < valores.length; j++) {
            if (valores[j] !== null && v.options[j] !== valores[j]) { coincide = false; break; }
          }
          if (coincide) { encontrada = v; break; }
        }

        if (!encontrada) return;

        if (inputId) inputId.value = encontrada.id;
        if (precioAhora) precioAhora.innerHTML = encontrada.price;
        if (precioAntes) {
          if (encontrada.compare_at_price) {
            precioAntes.innerHTML = encontrada.compare_at_price;
            precioAntes.style.display = '';
          } else {
            precioAntes.style.display = 'none';
          }
        }
        if (boton) {
          boton.disabled = !encontrada.available;
          boton.textContent = encontrada.available ? textoDisponible : textoAgotado;
        }
      }

      bloque.querySelectorAll('[data-mt-opcion]').forEach(function (grupo) {
        grupo.querySelectorAll('.mt-opcion__valor').forEach(function (btn) {
          btn.addEventListener('click', function () {
            grupo.querySelectorAll('.mt-opcion__valor').forEach(function (b) {
              b.classList.toggle('mt-activa', b === btn);
            });
            actualiza();
          });
        });
      });
    });
  }

  /* --- Marquesinas: duración según contenido ---------------------------- */
  function initMarquesinas(raiz) {
    var pistas = (raiz || document).querySelectorAll('[data-mt-velocidad]');
    pistas.forEach(function (pista) {
      var seg = parseFloat(pista.getAttribute('data-mt-velocidad')) || 40;
      pista.style.animationDuration = seg + 's';
    });
  }

  /* --- Zoom (lupa) de la imagen del producto ---------------------------- */
  function initZoom(raiz) {
    var marcos = (raiz || document).querySelectorAll('[data-mt-zoom]');
    if (!marcos.length) return;

    /* Sin cursor (móvil/tableta) no tiene sentido: se deja la foto quieta. */
    if (window.matchMedia('(hover: none), (pointer: coarse)').matches) return;

    marcos.forEach(function (marco) {
      if (marco.dataset.mtZoomListo === '1') return;
      marco.dataset.mtZoomListo = '1';

      var img = marco.querySelector('[data-mt-principal]');
      if (!img) return;

      var nivel = parseFloat(marco.getAttribute('data-mt-zoom')) || 2;
      if (nivel <= 1) return;

      marco.classList.add('mt-zoomable');

      var lupa = null;
      if (marco.getAttribute('data-mt-lupa') === '1') {
        lupa = document.createElement('span');
        lupa.className = 'mt-lupa';
        marco.appendChild(lupa);
      }

      function mueve(e) {
        var caja = marco.getBoundingClientRect();
        var x = (e.clientX - caja.left) / caja.width;
        var y = (e.clientY - caja.top) / caja.height;
        x = Math.min(Math.max(x, 0), 1);
        y = Math.min(Math.max(y, 0), 1);

        img.style.transformOrigin = (x * 100) + '% ' + (y * 100) + '%';
        img.style.transform = 'scale(' + nivel + ')';

        if (lupa) {
          var lado = caja.width / nivel;
          lupa.style.width = lado + 'px';
          lupa.style.height = lado + 'px';
          lupa.style.left = (x * caja.width - lado / 2) + 'px';
          lupa.style.top = (y * caja.height - lado / 2) + 'px';
        }
      }

      marco.addEventListener('mouseenter', function () { marco.classList.add('mt-zoom-activo'); });
      marco.addEventListener('mousemove', mueve);
      marco.addEventListener('mouseleave', function () {
        marco.classList.remove('mt-zoom-activo');
        img.style.transform = '';
        img.style.transformOrigin = '';
      });
    });
  }

  /* --- Foto que vuela al carrito al pedir ------------------------------- */
  function initVolarAlCarrito(raiz) {
    var cajas = (raiz || document).querySelectorAll('[data-mt-volar]');
    if (!cajas.length) return;

    var raizTienda = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    function esperar(ms) {
      return new Promise(function (ok) { setTimeout(ok, ms); });
    }

    function enPantalla(r) {
      return r.width > 0 && r.bottom > 40 && r.top < window.innerHeight - 40;
    }

    /* Si la cabecera fija está escondida por el scroll, la mostramos
       para que la foto tenga dónde aterrizar. */
    function mostrarCabecera() {
      var cab = document.querySelector('.shopify-section-header-hidden');
      if (!cab) return Promise.resolve();
      cab.classList.remove('shopify-section-header-hidden');
      return esperar(260);
    }

    function volar(caja) {
      var seccion = caja.closest('.mt-prod') || document;
      var foto = seccion.querySelector('[data-mt-principal]');
      var boton = caja.querySelector('[type="submit"]');
      if (!foto) return Promise.resolve();

      return mostrarCabecera().then(function () {
        var icono = document.getElementById('cart-icon-bubble');
        var rf = foto.getBoundingClientRect();
        var rb = boton ? boton.getBoundingClientRect() : rf;

        /* Salida: la foto si se ve; si no (móvil con scroll), una miniatura
           que sale del propio botón. */
        var ini;
        if (enPantalla(rf)) {
          var lado = Math.min(rf.width, rf.height, 420);
          ini = { x: rf.left + rf.width / 2, y: rf.top + rf.height / 2, lado: lado };
        } else {
          ini = { x: rb.left + rb.width / 2, y: rb.top + rb.height / 2, lado: 110 };
        }

        /* Llegada: el icono del carrito, o la esquina superior derecha. */
        var fin;
        var ri = icono ? icono.getBoundingClientRect() : null;
        if (ri && ri.width > 0 && ri.top >= 0 && ri.bottom <= window.innerHeight) {
          fin = { x: ri.left + ri.width / 2, y: ri.top + ri.height / 2 };
        } else {
          fin = { x: window.innerWidth - 40, y: 36 };
        }

        var clon = document.createElement('img');
        clon.src = foto.currentSrc || foto.src;
        clon.alt = '';
        clon.className = 'mt-volando';
        clon.style.width = ini.lado + 'px';
        clon.style.height = ini.lado + 'px';
        clon.style.left = (ini.x - ini.lado / 2) + 'px';
        clon.style.top = (ini.y - ini.lado / 2) + 'px';
        document.body.appendChild(clon);

        var dx = fin.x - ini.x;
        var dy = fin.y - ini.y;
        var arco = Math.min(160, Math.abs(dy) * 0.35 + 60);
        var escalaFin = Math.max(0.06, 28 / ini.lado);

        var anim = clon.animate([
          { transform: 'translate(0px, 0px) scale(1)', opacity: 1, borderRadius: '18px' },
          { transform: 'translate(' + (dx * 0.45) + 'px, ' + (dy * 0.45 - arco) + 'px) scale(0.55)', opacity: 1, offset: 0.45 },
          { transform: 'translate(' + dx + 'px, ' + dy + 'px) scale(' + escalaFin + ')', opacity: 0.5, borderRadius: '50%' }
        ], { duration: 820, easing: 'cubic-bezier(.55, .06, .25, 1)', fill: 'forwards' });

        return anim.finished.then(function () {
          clon.remove();
          if (icono) {
            icono.classList.remove('mt-carrito-salto');
            void icono.offsetWidth;
            icono.classList.add('mt-carrito-salto');
          }
        }, function () { clon.remove(); });
      });
    }

    function actualizarBurbuja() {
      return fetch(raizTienda + '?sections=cart-icon-bubble')
        .then(function (r) { return r.json(); })
        .then(function (datos) {
          var html = datos && datos['cart-icon-bubble'];
          var icono = document.getElementById('cart-icon-bubble');
          if (!html || !icono) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var dentro = doc.querySelector('.shopify-section');
          if (dentro) icono.innerHTML = dentro.innerHTML;
        })
        .catch(function () {});
    }

    cajas.forEach(function (caja) {
      var form = caja.querySelector('form[action*="/cart/add"]');
      if (!form || form.dataset.mtVolarListo === '1') return;
      form.dataset.mtVolarListo = '1';

      form.addEventListener('submit', function (e) {
        /* Navegador muy antiguo: se envía como siempre. */
        if (!window.fetch || !window.Promise || !window.FormData) return;

        e.preventDefault();
        /* Evita pedidos dobles sin desactivar el botón (desactivado se ve gris
           y con el cursor de prohibido, y parece que no deja volver a pedir). */
        if (form.dataset.mtEnviando === '1') return;
        form.dataset.mtEnviando = '1';
        var boton = form.querySelector('[type="submit"]');
        if (boton) { boton.classList.add('mt-btn--cargando'); boton.setAttribute('aria-busy', 'true'); }
        function soltarBoton() {
          form.dataset.mtEnviando = '0';
          if (boton) { boton.classList.remove('mt-btn--cargando'); boton.removeAttribute('aria-busy'); }
        }

        var aviso = document.querySelector('cart-notification');
        var datos = new FormData(form);
        if (aviso) {
          datos.append('sections', 'cart-notification-product,cart-notification-button,cart-icon-bubble');
          datos.append('sections_url', window.location.pathname);
        }

        var anadir = fetch(raizTienda + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: datos
        }).then(function (r) {
          if (!r.ok) throw new Error('No se pudo añadir');
          return r.json();
        });

        /* La animación es opcional (ajuste del editor y "reducir movimiento").
           Seguro: si el navegador la congela, seguimos tras 1,6 s. */
        var conVuelo = caja.getAttribute('data-mt-volar') === '1' && !reduce && Element.prototype.animate;
        var vuelo = conVuelo
          ? Promise.race([volar(caja), esperar(1600)]).then(function () {
              document.querySelectorAll('.mt-volando').forEach(function (n) { n.remove(); });
            })
          : Promise.resolve();

        Promise.all([anadir, vuelo])
          .then(function (res) {
            var respuesta = res[0];
            soltarBoton();
            /* Se queda en la página y aparece el aviso "Artículo agregado"
               con "Ver carrito" y "Finalizar pedido". */
            if (aviso && respuesta && respuesta.sections && typeof aviso.renderContents === 'function') {
              try {
                aviso.renderContents(respuesta);
                return;
              } catch (err) { /* sigue abajo */ }
            }
            return actualizarBurbuja();
          })
          .catch(function () {
            /* Si algo falla, envío normal: el cliente nunca se queda atascado. */
            document.querySelectorAll('.mt-volando').forEach(function (n) { n.remove(); });
            soltarBoton();
            HTMLFormElement.prototype.submit.call(form);
          });
      });
    });
  }

  /* Botón "atrás" del navegador: la página vuelve de la memoria con el
     carrito antiguo. Al volver, se refresca el número del carrito y,
     si es la propia página del carrito, se recarga. */
  if (!window.mtPageshowListo) window.addEventListener('pageshow', function (e) {
    var desdeMemoria = e.persisted;
    if (!desdeMemoria && window.performance && performance.getEntriesByType) {
      var nav = performance.getEntriesByType('navigation')[0];
      desdeMemoria = !!(nav && nav.type === 'back_forward');
    }
    if (!desdeMemoria || !window.fetch) return;

    var raizTienda = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var enCarrito = /\/cart\/?$/.test(window.location.pathname);

    fetch(raizTienda + 'cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (carrito) {
        if (enCarrito) {
          var filas = document.querySelectorAll('cart-items .cart-item').length;
          var vacioEnPantalla = !!document.querySelector('cart-items.is-empty');
          var vacioReal = carrito.item_count === 0;
          if (e.persisted || vacioReal !== vacioEnPantalla || (!vacioReal && filas !== carrito.items.length)) {
            window.location.reload();
          }
          return;
        }
        var aviso = document.querySelector('cart-notification');
        if (aviso && typeof aviso.close === 'function') aviso.close();
        return fetch(raizTienda + '?sections=cart-icon-bubble', { cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (datos) {
            var html = datos && datos['cart-icon-bubble'];
            var icono = document.getElementById('cart-icon-bubble');
            if (!html || !icono) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var dentro = doc.querySelector('.shopify-section');
            if (dentro) icono.innerHTML = dentro.innerHTML;
          });
      })
      .catch(function () {});
  });
  window.mtPageshowListo = true;

  function initTodo(raiz) {
    initReveals();
    initFaq(raiz);
    initGaleria(raiz);
    initVariantes(raiz);
    initMarquesinas(raiz);
    initZoom(raiz);
    initVolarAlCarrito(raiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initTodo(document); });
  } else {
    initTodo(document);
  }

  /* Cuando el editor de Shopify recarga una sección, reinicializa. */
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
  document.addEventListener('shopify:section:select', function (e) { initTodo(e.target); });
})();
